<div class="flex-container" #divContamination (click)="onMouseClick($event)">
  <div class="singleLineForProgSettings">
    <div style="float:right;">
      <span>
        <fa-icon [icon]="faCog"></fa-icon>
      </span>
      <div class="btn" style="padding-top:0px;" data-backdrop="static" data-toggle="modal" data-target="#foProgramSetting">Program Settings</div>
    </div>
  </div>

  <div class="horizontalcard">
    <div class="formGroup">
      <label>Operating Conditions and Time</label>
    </div>
    <div class="formGroup">
      <div class="row flex-wrapper">
        <div class="section1">
          <span class="lblheader1">Running Time / year</span>
          <input type="text" class="txtheader" #txtRunningTime [(ngModel)]='contamination.runningTime' (focus)="onFocusEvent('Runningtime',0)" (change)="calcTotAirVolume()" required style="height: 33px;">
          <span class="lbluom">hours</span>
          <span class="calculator pointer" data-backdrop="static" data-toggle="modal" data-target="#foCalculate"><fa-icon class="fa-cal" [icon]='faCalculator'></fa-icon></span>
        </div>
        <div class="section2">
          <span class="lblheader2">Temperature</span>
          <input type="text" class="txtheader" #txtTemperature (focus)="onFocusEvent('Temperature', 0)" (change)="updateGasConcentration()" [(ngModel)]="contamination.temperature" autocomplete="true" required style="height: 33px;">
          <datalist #datalistTemperature style="height:180px;overflow-x:hidden; overflow-y:auto;" >
            <option *ngFor="let item of temperatureList" [ngValue]="item" >{{ item }}</option>
          </datalist>
          <span class="lbluom">{{UnitsFromUserData.Temperature}}</span>
        </div>
        <div class="section1">
          <span class="lblheader1">Air Flow</span>
          <input type="text" class="txtheader" #txtAirflow (focus)="onFocusEvent('Airflow', 0)" [(ngModel)]="contamination.airflow" (change)="calcTotAirVolume()" autocomplete="true" required style="height: 33px;">
          <datalist #datalistAirflow style="height:160px; overflow-x:hidden; overflow-y:auto;">
            <option *ngFor="let item of airflowList" [ngValue]="item" >{{ item }}</option>
          </datalist>
          <span class="lbluom">{{contamination.airflowUnit}}</span>
        </div>
        <div class="section2">
          <span class="lblheader2">Relative Humidity</span>
          <!-- <input type="text" class="txtheader" #txtRH (focus)="onFocusEvent('RH', 0)" [(ngModel)]="contamination.relativeHumidity" autocomplete="true" required style="height:33px;">
            <datalist #datalistRH style="height:160px; overflow-x:hidden; overflow-y:auto;">
              <option *ngFor="let item of RHList" [ngValue]="item" >{{ item }}</option>
            </datalist>
            <span class="lbluom">%</span> -->
            <label class="lbluom">{{contamination.relativeHumidity}} %</label> 
        </div>
        <div class="section1">
          <span class="lblheader1">Total Air Volume</span>
          <span style="color:#00673E; font-weight:bold">{{totAirVolume}}</span>
        </div>
      </div>
    </div>
  </div>

  <div class="title columnFlex">
    <div class="singleLine">
      <label style="font-size:large">Solutions</label>
    </div>
  </div>

  <div class="horizontalcard">
    <div class="formGroup">
      <div class="flex-nowrap row" >
        <div *ngFor="let sol of solutions; let i = index;" class="col-lg-5 col-md-5 col-sm-5 stagingSolutions">
          <div id="divSolutionName">
            <span *ngIf="!arrSolEditMode[i] else editSolName">
              <span style="width:70%; font-size:20px;" >{{sol.solutionName}}</span>
              <fa-icon class="fab fa-angular fa-2x" [icon]="faCheckCircle" (click)="toggleEditMode(i)" style="font-size: 1.5em; margin-top:-5px;"></fa-icon>
              <img *ngIf="i>0" (click)='removeSolution(i)' src="assets/images/trash_icon.png" style="width:26px;height:26px;margin-left:15px;">
            </span>
            <ng-template #editSolName >
              <input *ngIf="i===0" type="text" id="txtSolName1" [(ngModel)]="solName1" maxlength=25 style="width:80%;" >
              <input *ngIf="i===1" type="text" id="txtSolName2" [(ngModel)]="solName2" maxlength=25 style="width:80%;" >
              <input *ngIf="i===2" type="text" id="txtSolName3" [(ngModel)]="solName3" maxlength=25 style="width:80%;" >
              <img src="assets/images/edit.png" (click)="toggleEditMode(i)" style="width:26px; height:26px; margin-left:7%;">
            </ng-template>
          </div>

          <div id="divSolution"  class="stagingfilter">
            <div class="Filterbody">
              <div class="formGroup">
                <div class="formGroup double">
                  <div >
                    <span>Filter</span>
                    <div *ngIf="sharedService.loadFilterListForSolsPage===true" class="disableFilterBtn" style="color:#6fb39b; font-weight:500;">                      
                      Preparing Contamination Lists...Please wait
                      <div class="spinner-border" role="status">
                          <span class="sr-only"></span>
                      </div>                                     
                    </div>
                    <div>         
                      <input id="txtContamination{{i}}" [disabled]=sharedService.loadFilterListForSolsPage class="soltxtinputs" type="text" (focus)="onFocusEvent('Contamination', i)" (keyup)="searchGas(i)" style="height:35px;" autocomplete="off">                
                      <!-- <div style="float:right;width:23%;">
                        <div *ngIf="loading===true" >
                          <div class="spinner-border" role="status">
                            <span class="sr-only">Loading...</span>
                          </div>
                        </div>
                      </div> -->
                      <datalist id="datalistContamination{{i}}" style="height:200px; overflow-x:hidden; overflow-y:auto;" >
                        <option *ngFor="let astmGas of contaminationList" [ngValue]="astmGas.ChemID" (click)="selectContaminationType(astmGas, i, true)">{{ astmGas.ChemName }}</option>
                      </datalist>
                    </div>             
                  </div>
                </div>
              </div>

              <div class="formGroup double">
                <div class="formGroup">
                  <div>
                    <span class="sollbls">Media</span>
                    <div *ngIf="sharedService.loadFilterListForSolsPage===true" class="disableFilterBtn" style="color:#6fb39b; font-weight:500;">                      
                        Preparing Media Lists...Please wait
                        <div class="spinner-border" role="status">
                            <span class="sr-only"></span>
                        </div>                                     
                    </div>
                    <div>
                      <input id="txtMedia{{i}}" [disabled]=sharedService.loadFilterListForSolsPage class="soltxtinputs" type="text" (focus)="onFocusEvent('Media', i)" (keyup)="searchMedia(i)" style="height:35px;" autocomplete="off">
                      <datalist id="datalistMedia{{i}}" style="overflow-x:hidden; overflow-y:auto; height:125px;">
                        <option *ngFor="let media of mediaList" [ngValue]="media.Id" (click)="selectMedia(media,i)">{{ media.MediaName }}</option>
                      </datalist>           
                    </div>
                  </div>            
                </div>
              </div>

              <div class="formGroup double">
                <div class="formGroup">
                  <div>
                    <span class="sollbls">Concentration</span>
                    <div>
                      <input *ngIf="sol.solutionID == 1" id="txtConcentration" type="text" class="soltxtinputs" [(ngModel)]="concentrationValue1" (change)="detectKeyChanges('Concentration', 0)" style="height:35px;">
                      <input *ngIf="sol.solutionID == 2" id="txtConcentration" type="text" class="soltxtinputs" [(ngModel)]="concentrationValue2" (change)="detectKeyChanges('Concentration', 1)" style="height:35px;">
                      <input *ngIf="sol.solutionID == 3" id="txtConcentration" type="text" class="soltxtinputs" [(ngModel)]="concentrationValue3" (change)="detectKeyChanges('Concentration', 2)" style="height:35px;">
                      <label class="operatinglabels">{{selectedConcUnit}}</label>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          <!-- </div> -->
          </div>
        </div>
      </div>

       <!-- Add Solution - Start -->
       <div class="addSolutionSection" (click)='addSolution()' *ngIf="solutions.length < 3">
        <div class="addContent">
          <span class="addClick">
          <span style="font-weight: 650; font-size:26px;">
            <fa-icon class="iconInformational pointer" [icon]="faInfoCircle" id="AddSolutionInfoBtn" (mouseenter)="showHideInfoToggle('AddSolutionInfo')" (mouseleave)="showHideInfoToggle('AddSolutionInfo')"></fa-icon>
              <div id="divAddSolutionInfo" style="margin-top: -75px;margin-left:-320px;">
                <div class="InfoContent">
                Click on "Add Solution" to add a solution to the analysis.
                New solution will appear beside the current solution.
                </div>
                <div style="margin-top:18px;margin-left:280px;" id="arrow" data-popper-arrow></div>
              </div>
            Add  Solution &nbsp;&nbsp;&nbsp; <fa-icon [icon]="faPlus"></fa-icon> </span>
          </span>
        </div>
        </div>
      <!-- Add Solution - End -->
    </div>
  </div>

  <div class="next-button-content">
    <button class="button-content ripple" (click)='next()'>
        <span class='space'>Next</span> <fa-icon [icon]="faAngleRight"></fa-icon>
    </button>
  </div>

</div>

<!-- running time calculator -->
<div class="modal fade" id="foCalculate" tabindex="-1" role="dialog" aria-labelledby="foCalculate" aria-hidden="true">
  <div class="modal-dialog modal-dialog-centered" role="document">
      <div class="foCalculator fan">
          <div class="modal-content">
              <div class="modal-header">
                  <span><h5 style="margin-left:-3px;" class="modal-title" id="exampleModalLongTitle">Calculate Running Time</h5></span>
                  <button type="button" class="close" data-dismiss="modal" aria-label="Close" style="background:white; border:none; margin-top:-5%;">
                      <span aria-hidden="true">&times;</span>
                  </button>
              </div>
              <div class="modal-body">
                <div class="foOutputValue" style="margin-top:-20px;">
                    <div id='divTotalRT' style="margin-left:10px; color:green;"></div>
                </div>
                <div class="foInputs">
                    <div class="formGroup double">
                        <label>Hours / Day</label>
                        <select [(ngModel)]="hoursperdayval" (change)="calcRT(false)" class="dropdown-modify">
                          <option disabled selected value=''></option>
                          <option *ngFor="let item of hoursperDayList" [ngValue]="item">{{item}}</option>
                      </select>
                    </div>
                    <div class="formGroup double">
                        <label>Days / Week</label>
                        <select [(ngModel)]="daysperweekval" (change)="calcRT(false)" class="dropdown-modify">
                          <option disabled selected value=''></option>
                          <option *ngFor="let item of daysperWeekList" [ngValue]="item">{{item}}</option>
                      </select>
                    </div>
                    <div class="formGroup double">
                      <label>Weeks / Year</label>
                      <select [(ngModel)]="weeksperyearval" (change)="calcRT(false)" class="dropdown-modify">
                        <option disabled selected value=''></option>
                        <option *ngFor="let item of weeksperYearList" [ngValue]="item">{{item}}</option>
                    </select>
                  </div>
                </div>
                  <div class="btnGroup">
                    <div class="cancel pointer" data-dismiss="modal" >Cancel</div>
                    <div class="next-button-content">
                        <button class="button-content ripple" data-dismiss="modal" (click)='updateRuningTime()'>
                        <span class='space'>Done</span>
                        </button>
                    </div>
                  </div>
              </div>
              </div>
          </div>
    </div>
</div>

<!-- program settings  -->
<div class="modal fade" id="foProgramSetting" tabindex="-1" role="dialog" aria-labelledby="foProgramSetting" aria-hidden="true" >
  <div class="modal-dialog modal-dialog-centered" role="document">
    <div class="foProgramsetting">
      <div class="modal-content">
        <div class="modal-header">
          <span><h5 class="modal-title" id="progsettingpopup">Program Settings</h5></span>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)='triggerASTMCancelFromProgSettings()' style="margin-right:5%;background-color: white; border: none;">
              <span aria-hidden="true">&times;</span>
          </button>
        </div>
        <div class="modal-body" style="width:450px;">
          <div class="formGroup formRow">
            <div class="formGroup">
              <label>Unit (SI / US)</label>
              <select [(ngModel)]="selUnitFromProgSettings" (change)="toggleUnit()" class="dropdown-modify">
                <option disabled selected value=''></option>
                <option *ngFor="let item of unitlist" [ngValue]="item.value">{{item.display}}</option>
              </select>
            </div>
          </div>
          <div class="formGroup formRow">
            <div class="formGroup">
              <label>Concentration (ppb / mg/m³)</label>
              <select [(ngModel)]="selConcUnitFromProgSettings" class="dropdown-modify">
                <option disabled selected value=''></option>
                <option *ngFor="let item of concUnitlist.List" [ngValue]="item">{{item}}</option>
              </select>
            </div>
          </div>
          <div class="formGroup formRow">
            <div class="formGroup">
              <label>Airflow (m³/h / CFM / m³/s / L/s)</label>
              <select [(ngModel)]="selAirFlowUnitFromProgSettings" [disabled]="disableFlag" class="dropdown-modify">
                <option disabled selected value=''></option>
                <option *ngFor="let item of airFlowUnitlist.List" [ngValue]="item">{{item}}</option>
              </select>
            </div>
          </div>
          <div class="btnGroupPrgSetting">
            <div class="cancel pointer" data-dismiss="modal" (click)='triggerASTMCancelFromProgSettings()'>Cancel</div>
              <div class="next-button-content">
                <button class="button-content ripple" data-dismiss="modal" (click)='triggerDoneFromProgSettings()'>
                  <span class='space'>Done</span>
                </button>
              </div>
            </div>
        </div>
      </div>
    </div>
  </div>
</div>

